const createDropdownOptionsMapper = (prefix) => (option) => ({
  ...option,
  key: option.value,
  e2eId: `${prefix}-${option.value}`,
});

export default createDropdownOptionsMapper;
